import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { AbstractFinanceFromComponent } from '../abstract-v12-retail-finance-from.component';
@Component({
    selector: 'v12-retail-finance-from-basket',
    templateUrl: 'v12-retail-finance-from-basket.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, ICmsClientModule, TranslatePipe]
})
export class FinanceFromBasketComponent extends AbstractFinanceFromComponent { }
